import MuiFormLabel from "@mui/material/FormLabel";
const FormLabel = MuiFormLabel;
export default FormLabel;
